module.exports = __webpack_public_path__ + "static/img/326_TO8_2513.c4c0ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/326_TO8_2513.jpg
// module id = VaF4
// module chunks = 0